export function validUrl(url: string): boolean {
  try {
    const newUrl = new URL(url);

    const validProtocol = url.startsWith('https://') || url.startsWith('http://');

    // Check if hostname has at least one dot and a valid TLD
    // This allows: a.com, example.com, sub.example.com, etc.
    const parts = newUrl.hostname.split('.');
    const validHostname =
      parts.length >= 2 &&
      parts[parts.length - 1].length >= 2 && // TLD at least 2 chars
      /^[a-z]+$/i.test(parts[parts.length - 1]) && // TLD is letters only
      parts.every((part) => part.length > 0 && /^[a-z0-9]([a-z0-9-]*[a-z0-9])?$/i.test(part));

    return validProtocol && validHostname;
  } catch (e) {
    return false;
  }
}
